<template>
    <div id="app">
        <objHeader :propUserName="userNameTest"></objHeader>
        <router-view class="myBody"/>
        <objFooter :propUserName="userNameTest"></objFooter>
    </div>
</template>

<script>
    import objHeader from "./components/header";
    import objFooter from "./components/footer";

    export default {
        name: 'App',
        components: {objHeader, objFooter},
        data() {
            return {
                userNameTest: localStorage.getItem("userName")
            };
        }
    }
</script>

<style scoped lang="scss">

    @import 'assets/scss/general.scss';

    #app {
        /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;

        font-family: 'Source Sans Pro', Helvetica, Arial, sans-serif !important;
    }

    .myBody {
        margin-top: calc(#{$bodyTopMargin});
        margin-bottom: calc(#{$footer} + #{$bodyTopMargin});
    }

</style>



// WEBPACK FOOTER //
// src/App.vue